import React from 'react';
import {ShowGuesser} from "@api-platform/admin";

const AirportInfoShow = (props) => (
        <ShowGuesser {...props} resource="covid19-airport-infos"/>
);

export default AirportInfoShow;
